import React, { FC } from 'react';
import { Container } from '../../components/container/container';
import {
  IconIndicators,
  IndicatorsBase,
  IndicatorsCategory,
  IndicatorsContentWrap,
  IndicatorsInfo,
  IndicatorsMetric,
  IndicatorsTitle,
  IndicatorsWrap,
  MarkerIndicators,
  ButtonMoreIndicatorsWrap,
} from './style';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Button } from '@plataformaxvia/design-system';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';

export interface Indicator {
  icon?: string;
  value: number;
  detail: string;
}

export interface IndicatorsProps {
  indicators: Indicator[];
}

export const Indicators: FC<IndicatorsProps> = ({ indicators }) => {
  return (
    <IndicatorsWrap>
      <Container>
        <IndicatorsContentWrap>
          <IndicatorsTitle role="heading" aria-level={2}>
            Indicadores dos nossos serviços
          </IndicatorsTitle>
          <IndicatorsBase>
            {indicators &&
              indicators.length > 0 &&
              indicators.map((indicator, index) => (
                <React.Fragment key={index}>
                  <IndicatorsInfo>
                    <IconIndicators>
                      <FontAwesomeIcon
                        size="2x"
                        icon={indicator?.icon as IconProp}
                      />
                    </IconIndicators>
                    <div>
                      <IndicatorsMetric>{indicator.value}</IndicatorsMetric>
                      <IndicatorsCategory>
                        {indicator.detail}
                      </IndicatorsCategory>
                    </div>
                  </IndicatorsInfo>
                  {index < indicators.length - 1 && <MarkerIndicators />}
                </React.Fragment>
              ))}
          </IndicatorsBase>
        </IndicatorsContentWrap>
        <ButtonMoreIndicatorsWrap>
          <Button
            iconEnd={<ArrowRightAltIcon />}
            label="Mais indicadores"
            size="medium"
            aria-label="Mais indicadores"
            className="button-more-indicators"
            onClick={() =>
              window.open(
                'https://hubbi.pe.gov.br/hub/public/apps/67b4d24840cd819e272eac3d/',
                '_blank'
              )
            }
          />
        </ButtonMoreIndicatorsWrap>
      </Container>
    </IndicatorsWrap>
  );
};
